import { Component, Inject, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ENTITLEMENTS, EntitlementsHelperService, LINE_OF_BUSINESS_ENUM, LOGIN_INFO_REDUCER_NAME, UserInfoStateStructure, USER_ROLE } from "@ptl/account-management";
import { AuthoringModeService } from "src/app/shared/services/authoring-mode.service";
import { ReducerUtilityService } from "src/app/shared/utility-services/reducer-utility.service";

@Component({
    selector: 'app-book-of-business-modal',
    templateUrl: './book-of-business-modal.component.html',
    styleUrls: ['./book-of-business-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class BookOfBusinessModalComponent implements OnInit {

    @Input() linkType: string = "sso-link";
    @Input() ssoType: string;
    @Input() ssoLabel: string;
    hasEntitlements;
    content;

    modalContent = {
        title: 'AGENCY BOOK OF BUSINESS',
        includeAll: 'Include all agencies',
        selectAgencies: 'Select agency',
        selectAll: 'Select All',
        deselectAll: 'Clear',
        cancel: 'Cancel',
        download: 'Download Excel',
    }

    checkBoxModel = {};
    all = {
        selectAll: false,
        count: 0,
        empty: false,
        nameFilter: '',
    };
    // touched = false;
    selectedAgencyIds = [];
    agencyList = [];


    // This is the Content config from the page.
    lineOfBusiness;
    // This is the internal storage location for the agency.
    lob;
    loginData: UserInfoStateStructure;
    agencyIncludeSsn;
    agencyGenIncludeSsn;
    agencyStdIncludeSsn;
    agencyIncludeMbi;
    agencyGenIncludeMbi;
    agencyStdIncludeMbi;
    isRequiringAdditionalQueryParam;
    isPreferredAgency;
    isStandardAgency;
    isAgencySource;
    isGenAgencySource;
    isStdAgencySource;
    needSelect: string = "";

    constructor(
        private entitlementService: EntitlementsHelperService,
        private authoringMode: AuthoringModeService,
        private reducerUtilityService: ReducerUtilityService,
        private dialogRef: MatDialogRef<BookOfBusinessModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {
            lineOfBusiness: string,
            loginData: any,
            agencyIncludeSsn: boolean,
            agencyGenIncludeSsn: boolean,
            agencyStdIncludeSsn: boolean,
            agencyIncludeMbi: boolean,
            agencyGenIncludeMbi: boolean,
            agencyStdIncludeMbi: boolean,
            isRequiringAdditionalQueryParam: boolean,
            isPreferredAgency: boolean,
            isStandardAgency: boolean,
            isAgencySource: boolean,
            isGenAgencySource: boolean,
            isStdAgencySource: boolean
        }
    ) { }


    async ngOnInit() {


        this.loginData = this.data.loginData;
        this.agencyIncludeSsn = this.data.agencyIncludeSsn;
        this.agencyGenIncludeSsn = this.data.agencyGenIncludeSsn;
        this.agencyStdIncludeSsn = this.data.agencyStdIncludeSsn;
        this.agencyIncludeMbi = this.data.agencyIncludeMbi;
        this.agencyGenIncludeMbi = this.data.agencyGenIncludeMbi;
        this.agencyStdIncludeMbi = this.data.agencyStdIncludeMbi;
        this.isRequiringAdditionalQueryParam = this.data.isRequiringAdditionalQueryParam;
        this.isPreferredAgency = this.data.isPreferredAgency;
        this.isStandardAgency = this.data.isStandardAgency;
        this.isAgencySource = this.data.isAgencySource;
        this.isGenAgencySource = this.data.isGenAgencySource;
        this.isStdAgencySource = this.data.isStdAgencySource;

        this.lob = await this.entitlementService.getCurrentLobPromise();
        this.loginData = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);

        this.agencyList = this.loginData.userInfo.agencies;

        this.agencyList.forEach((agency) => {
            this.checkBoxModel[agency.agencyId] = false;
        });


        this.selectAll();

    }


    downloadReport() {
        //         this.touched = true;
        if (this.needSelect === "true") {
            this.all.empty = true;
        } else if (this.needSelect === "false") {
            this.all.empty = false;
        } else {
            return;
        }

        let agencyIds = [],
            reportServiceUrl = '/cmcrst/x-services/salesReport/agency/' + this.data.lineOfBusiness + '/';

        if (this.needSelect === "true") {

            let currentAgencyId = this.loginData.userInfo.agencyInfo.selectedAgencies[this.lob].agencyId;

            // return this.loginData.userInfo.agencyInfo.selectedAgencies[this.lob].agencyId;


            agencyIds.push(currentAgencyId);

        } else {
            agencyIds = this.selectedAgencyIds;
        }

        if (!this.all.empty && agencyIds.length > 0) {

            reportServiceUrl += agencyIds.join(",");

            // Start query params
            if (this.agencyIncludeSsn || this.agencyGenIncludeSsn || this.agencyStdIncludeSsn || this.agencyIncludeMbi || this.agencyGenIncludeMbi || this.agencyStdIncludeMbi || (this.isRequiringAdditionalQueryParam && (this.isPreferredAgency || this.isStandardAgency))) {
                reportServiceUrl += "?";
            }

            // if there's already a query param....
            if ((reportServiceUrl.indexOf("?") !== -1) && (reportServiceUrl.indexOf("?") < reportServiceUrl.length - 1)) {
                reportServiceUrl += "&";
            }

            if (this.agencyIncludeSsn && this.isAgencySource) {
                reportServiceUrl += "includeSsn=" + this.agencyIncludeSsn;
            }

            if (this.agencyGenIncludeSsn && this.isGenAgencySource) {
                reportServiceUrl += "includeSsn=" + this.agencyGenIncludeSsn;
            }

            if (this.agencyStdIncludeSsn && this.isStdAgencySource) {
                reportServiceUrl += "includeSsn=" + this.agencyStdIncludeSsn;
            }


            if ((reportServiceUrl.indexOf("?") !== -1) && (reportServiceUrl.indexOf("?") < reportServiceUrl.length - 1)) {
                reportServiceUrl += "&";
            }

            if (this.agencyIncludeMbi && this.isAgencySource) {
                reportServiceUrl += "includeMbi=" + this.agencyIncludeMbi;
            }

            if (this.agencyGenIncludeMbi && this.isGenAgencySource) {
                reportServiceUrl += "includeMbi=" + this.agencyGenIncludeMbi;
            }

            if (this.agencyStdIncludeMbi && this.isStdAgencySource) {
                reportServiceUrl += "includeMbi=" + this.agencyStdIncludeMbi;
            }


            if (this.isRequiringAdditionalQueryParam) {

                if ((reportServiceUrl.indexOf("?") !== -1) && (reportServiceUrl.indexOf("?") < reportServiceUrl.length - 1)) {
                    reportServiceUrl += "&";
                }

                if (this.isPreferredAgency) {
                    reportServiceUrl += "agencytype=PREFERRED";
                } else if (this.isStandardAgency) {
                    reportServiceUrl += "agencytype=STANDARD";
                }
            }

            window.open(reportServiceUrl);
            this.closeModal();

        }
    };

    checkChange() {
        this.all.count = 0;
        // this.touched = true;
        this.selectedAgencyIds = [];
        this.agencyList.forEach((agency) => {
            if (this.checkBoxModel[agency.agencyId]) {
                this.all.count++;
                this.selectedAgencyIds.push(agency.agencyId);
            }
        });
        this.all.empty = this.all.count === 0 ? true : false;
    };

    includeSelect() {
        if (this.needSelect === 'true') {
            this.clearChecks();
        } else {
            this.selectAll();
        }

    }

    selectAll() {
        // this.touched = true;

        this.agencyList.forEach((agency) => {
            this.checkBoxModel[agency.agencyId] = true || false; // this should probably not be "true || false", but I'm not touching it
        });

        this.checkChange();

        this.all.count = this.all.selectAll ? this.agencyList.length : 0;
        this.all.empty = this.all.count === 0 ? true : false;
    };

    clearChecks() {
        this.all.selectAll = false;
        this.selectAll();
        this.selectedAgencyIds = [];
    };

    closeModal() {
        this.dialogRef.close();
    }

    // checkRequired() {
    //     return this.checkBoxModel.some(function (agency) {
    //         return this.checkBoxModel[agency.agencyId];
    //     });
    // };
}